var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EventTarget = /** @class */ (function () {
    function EventTarget() {
        this.eventMap = {};
    }
    EventTarget.prototype.addEventListener = function (eventName, handler) {
        var cbs = this.eventMap[eventName];
        if (!cbs) {
            cbs = [];
            this.eventMap[eventName] = cbs;
        }
        cbs.push(handler);
    };
    EventTarget.prototype.removeEventListener = function (eventName, handler) {
        var cbs = this.eventMap[eventName];
        if (!cbs) {
            return;
        }
        var idx = cbs.indexOf(handler);
        if (idx >= 0) {
            cbs.splice(idx, 1);
        }
    };
    EventTarget.prototype.dispatchEvent = function (event) {
        var eventName = event.type;
        var cbs = this.eventMap[eventName];
        if (cbs) {
            cbs.forEach(function (cb) { return cb && cb(event); });
        }
    };
    return EventTarget;
}());
export { EventTarget };
var SectionTarget = /** @class */ (function (_super) {
    __extends(SectionTarget, _super);
    function SectionTarget(section, index) {
        var _this = _super.call(this) || this;
        _this.index = index;
        _this.section = section;
        _this.animationProvider = section.animation;
        return _this;
    }
    SectionTarget.prototype.registerAnimation = function (animationProvider) {
        this.animationProvider = animationProvider;
    };
    return SectionTarget;
}(EventTarget));
export default SectionTarget;
